// extracted by mini-css-extract-plugin
export var divider = "_xv-0";